import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream-50 py-10 sm:py-20" aria-labelledby="garantia" data-id="element-133" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-134" data-mp="1o5zqk0x60943">
        <div className="flex flex-col gap-4 rounded-3xl border border-teal-800/15 bg-teal-50 p-5 sm:flex-row sm:items-start sm:gap-7 sm:p-9" data-id="element-135" data-mp="2223kdt44mfg1">
          <div className="flex items-center gap-3 sm:shrink-0 sm:flex-col sm:gap-0" data-id="element-136" data-mp="1x2iltjsvc93u">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-teal-800 sm:h-20 sm:w-20" data-id="element-137" data-mp="19co9r4gdiokn">
              <ShieldCheckIcon className="h-6 w-6 text-gold-400 sm:h-9 sm:w-9" aria-hidden="true" data-id="element-138" data-mp="1j4k6oc6q48na" />
            </span>
            <span className="font-display text-xs font-900 uppercase tracking-[0.14em] text-teal-800 sm:mt-2 sm:text-sm" data-id="element-139" data-mp="1edbx9g5e8na4">
              7 días
            </span>
          </div>

          <div data-id="element-140" data-mp="qlwu5l5sm1xt">
            <h2 id="garantia" className="font-display text-xl font-800 uppercase text-teal-900 sm:text-3xl" data-id="element-141" data-mp="lpg0kbftqvdc">
              Garantía total
            </h2>
            <p className="mt-1.5 font-display text-sm font-700 text-teal-700 sm:mt-2 sm:text-base" data-id="element-142" data-mp="oz9kqu71izie">
              Probalo durante 7 días o te devolvemos el 100%
            </p>
            
            <p className="mt-2 font-display text-xs font-800 uppercase tracking-[0.14em] text-gold-600 sm:mt-3 sm:text-sm" data-id="element-143" data-mp="ypuqr2p1n6bc">
              Sin riesgo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}